import { Box, IconButton, alpha, lighten, styled, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { FC } from 'react';

import HeaderUserbox from './Userbox';
import useCompanyDetails from 'hooks/useCompanyDetails';

interface HeaderProps {
  sidebarOpen: boolean;
  onToggleSidebar: () => void;
  /** show the sidebar toggle — hidden for flavours without a sidebar */
  showToggle?: boolean;
}

const HeaderWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'sidebarOpen',
})<{ sidebarOpen: boolean }>(
  ({ theme, sidebarOpen }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 6;
        background-color: ${alpha(theme.header.background, 0.95)};
        backdrop-filter: blur(3px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
        transition: ${theme.transitions.create(['left', 'width'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        })};
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: ${sidebarOpen ? theme.sidebar.width : '0'};
            width: auto;
        }
`
);

const Header: FC<HeaderProps> = ({
  sidebarOpen,
  onToggleSidebar,
  showToggle = true,
}) => {
  const theme = useTheme();
  const { logo, name } = useCompanyDetails();

  return (
    <HeaderWrapper
      className="top-header"
      display="flex"
      alignItems="center"
      sidebarOpen={sidebarOpen}
      sx={{
        boxShadow:
          theme.palette.mode === 'dark'
            ? `0 1px 0 ${alpha(
                lighten(theme.colors.primary.main, 0.7),
                0.15
              )}, 0px 2px 8px -3px rgba(0, 0, 0, 0.2), 0px 5px 22px -4px rgba(0, 0, 0, .1)`
            : `0px 2px 8px -3px ${alpha(
                theme.colors.alpha.black[100],
                0.2
              )}, 0px 5px 22px -4px ${alpha(
                theme.colors.alpha.black[100],
                0.1
              )}`,
      }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        {showToggle && (
          <IconButton
            aria-label="toggle sidebar"
            onClick={onToggleSidebar}
            sx={{ color: theme.colors.alpha.white[100] }}
          >
            <MenuIcon />
          </IconButton>
        )}
        <a href="/">
          <img src={logo} alt={name} />
        </a>
      </Box>
      <Box display="flex" alignItems="center">
        <HeaderUserbox />
      </Box>
    </HeaderWrapper>
  );
};

export default Header;
